import * as actions from './actions';
import {
    CLEAR_ERRORS,
    USERS_SUPPLIES_ERROR,
    USER_BORROWS_ERROR,
    WALLETS_ERROR,
    NETWORKS_ERROR,
    AGREEMENTS_ERROR,
    TOKENS_ERROR,
    INFO_ERROR,
    VAULT_ERROR,
    WITHDRAWAL_ERROR,
    DEPOSIT_ERROR,
    USER_VAULTS_ERROR,
    MARGIN_ACCOUNTS_ERROR,
    ORGANIZATION_MEMBERS_ERROR,
    USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR,
    USERS_VAULTS_PENDING_REWARDS_ERROR,
    COLLATERAL_AGREEMENT_ERROR,
    COLLATERAL_WALLET_ERROR,
    COLLATERAL_TOKENS_ERROR,
    COLLATERAL_GENERAL_ERROR,
    ASSET_PRICES_ERROR,
    ASSET_PRICE_ERROR,
    ASSET_PRICE_GENERAL_ERROR,
    AGREEMENT_ROLE_ERROR,
    TOKEN_PRICE_ERROR,
    AGREEMENT_CONTRACT_ERROR,
    AGREEMENT_GENERAL_ERROR,
    WALLET_BALANCE_ERROR,
    TOKEN_BALANCE_ERROR,
    AGREEMENT_DETAILS_ERROR,
    AGREEMENT_LEVERAGE_ERROR,
    REMOVE_AGREEMENT_CONTRACT_ERROR,
} from './constants';

export type ErrorState = {
    [key: string]: string[];
};

const defaultState: ErrorState = {
    USERS_SUPPLIES_ERROR: [],
    USER_BORROWS_ERROR: [],
    WALLETS_ERROR: [],
    NETWORKS_ERROR: [],
    AGREEMENTS_ERROR: [],
    TOKENS_ERROR: [],
    INFO_ERROR: [],
    VAULT_ERROR: [],
    WITHDRAWAL_ERROR: [],
    DEPOSIT_ERROR: [],
    USER_VAULTS_ERROR: [],
    MARGIN_ACCOUNTS_ERROR: [],
    ORGANIZATION_MEMBERS_ERROR: [],
    USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR: [],
    USERS_VAULTS_PENDING_REWARDS_ERROR: [],
    COLLATERAL_AGREEMENT_ERROR: [],
    COLLATERAL_WALLET_ERROR: [],
    COLLATERAL_TOKENS_ERROR: [],
    COLLATERAL_GENERAL_ERROR: [],
    ASSET_PRICES_ERROR: [],
    ASSET_PRICE_ERROR: [],
    ASSET_PRICE_GENERAL_ERROR: [],
    AGREEMENT_ROLE_ERROR: [],
    TOKEN_PRICE_ERROR: [],
    AGREEMENT_CONTRACT_ERROR: [],
    AGREEMENT_GENERAL_ERROR: [],
    WALLET_BALANCE_ERROR: [],
    TOKEN_BALANCE_ERROR: [],
    AGREEMENT_DETAILS_ERROR: [],
    AGREEMENT_LEVERAGE_ERROR: [],
};

export type ErrorAction =
    | ReturnType<TInferValueTypes<typeof actions>>
    | { type: 'AGREEMENT_DETAILS_ERROR'; payload: { message: string } }
    | { type: 'USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR'; payload: { message: string } }
    | { type: 'ASSET_PRICES_ERROR'; payload: { message: string } };

export default function error(state = defaultState, action: ErrorAction): ErrorState {
    switch (action.type) {
        case USERS_SUPPLIES_ERROR:
        case USER_BORROWS_ERROR:
        case WALLETS_ERROR:
        case NETWORKS_ERROR:
        case AGREEMENTS_ERROR:
        case TOKENS_ERROR:
        case INFO_ERROR:
        case VAULT_ERROR:
        case WITHDRAWAL_ERROR:
        case DEPOSIT_ERROR:
        case USER_VAULTS_ERROR:
        case MARGIN_ACCOUNTS_ERROR:
        case ORGANIZATION_MEMBERS_ERROR:
        case USERS_VAULTS_PENDING_REWARDS_ERROR:
        case COLLATERAL_AGREEMENT_ERROR:
        case COLLATERAL_WALLET_ERROR:
        case COLLATERAL_TOKENS_ERROR:
        case COLLATERAL_GENERAL_ERROR:
        case ASSET_PRICE_ERROR:
        case ASSET_PRICE_GENERAL_ERROR:
        case AGREEMENT_ROLE_ERROR:
        case TOKEN_PRICE_ERROR:
        case AGREEMENT_CONTRACT_ERROR:
        case AGREEMENT_GENERAL_ERROR:
        case WALLET_BALANCE_ERROR:
        case TOKEN_BALANCE_ERROR:
        case AGREEMENT_DETAILS_ERROR:
        case AGREEMENT_LEVERAGE_ERROR:
        case USERS_VAULTS_CONTRACT_NOT_AVAILABLE_ERROR:
        case ASSET_PRICES_ERROR: {
            if ('message' in action.payload) {
                const currentList = Array.isArray(state[action.type]) ? state[action.type] : [];

                if (!currentList.includes(action.payload.message)) {
                    return {
                        ...state,
                        [action.type]: [...currentList, action.payload.message],
                    };
                }
            }
            return state;
        }
        case CLEAR_ERRORS: {
            const newState = { ...state };
            if ('errorType' in action.payload && action.payload.errorType in newState) {
                newState[action.payload.errorType] = [];
            }
            return newState;
        }
        case REMOVE_AGREEMENT_CONTRACT_ERROR: {
            return {
                ...state,
                [AGREEMENT_CONTRACT_ERROR]: state[AGREEMENT_CONTRACT_ERROR].filter(
                    (msg) => msg !== action.payload.message,
                ),
            };
        }
        default: {
            return state;
        }
    }
}
